import React, { useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  AppBar,
  Toolbar,
  Typography,
} from "@material-ui/core/";
import { useSelector, useDispatch } from "react-redux";
import NavigationMenuItem from "./NavigationMenuItem";
import { isObjectEmpty } from "../../../utils/general";

const useStyle = makeStyles((theme) => ({
  root: {
    background: "#F1F1F1",
    boxShadow: "none",
    borderBottom: "1px solid #cccccc5e",
  },
}));

const NavigationItems = (props) => {
  const dispatch = useDispatch();
  const isUserLoggedIn = useSelector((state) => state.loginRequest.isLoggedIn);
  const classes = useStyle(props);
  const studentHoldData = useSelector(
    (state) => state.profileData.studentHoldData,
  );

  const noticeMessage = useSelector(
    (state) => state.selectClassData.noticeData,
  );
  const currentStudent = useSelector(
    (state) => state.selectClassData.currentStudent,
  );
  const [studentholdType, setStudentholdType] = useState([]);
  const [noticeMessages, setNoticeMessages] = useState([]);
  useEffect(() => {
    if (studentHoldData?.length > 0) {
      const sesHoldTypes = studentHoldData.map((item) => item?.ses_holdtype);

      const uniqueSesHoldTypes = [...new Set(sesHoldTypes)];

      setStudentholdType(uniqueSesHoldTypes);
    } else {
      setStudentholdType([]);
    }

    if (noticeMessage?.length > 0) {
      setNoticeMessages(noticeMessage);
    }
  }, [studentHoldData, noticeMessage]);

  // Define messages based on hold types
  const messages = {
    284210000:
      "Ton compte est suspendu pour la raison suivante : Suspension (études). Jusqu’à ce que cette suspension soit réglée, l'accès aux services est limité. Contacte au plus tôt le Registrariat : ",
    284210001:
      "Ton compte est suspendu pour la raison suivante : Suspension (finances). Jusqu’à ce que cette suspension soit réglée, l'accès aux services est limité. Contacte au plus tôt le bureau Finance : ",
    284210002:
      "Ton compte est suspendu pour la raison suivante : Suspension (administration). Jusqu’à ce que cette suspension soit réglée, l'accès aux services est limité. Contacte au plus tôt le Bureau International : ",
    943240001:
      "Ton compte est suspendu pour la raison suivante : Suspension (orientation). Jusqu’à ce que cette suspension soit réglée, l'accès aux services est limité. Contacte au plus tôt le Service d'orientation pédagogique : ",
  };

  const contactEmails1 = {
    284210000: "mailto:registraire@ustboniface.ca",
    284210001: "mailto:finances@ustboniface.ca",
    284210002: "mailto:international@ustboniface.ca",
    943240001: "mailto:orientation@ustboniface.ca",
  };
  const contactEmails = {
    284210001: "finances@ustboniface.ca",
    284210002: "international@ustboniface.ca",
    943240001: "orientation@ustboniface.ca",
    284210000: "registraire@ustboniface.ca",
  };
  console.log(studentholdType, "studentholdType");
  return (
    <AppBar position="static" classes={{ root: classes.root }}>
      {window.localStorage.getItem("isUserLoggedIn") || isUserLoggedIn ? (
        <>
          <Toolbar disableGutters>
            <Grid container item xs={12} sm={11} style={{ margin: "0 auto" }}>
              <NavigationMenuItem />
            </Grid>
          </Toolbar>
          {studentholdType.map((holdType) => (
            <Typography
              key={holdType}
              style={{
                fontSize: "0.85rem",
                background: "#efd6e1",
                color: "black",
                marginLeft: "4.8rem",
                width: "90%",
                paddingBottom: "0.5rem",
                paddingLeft: "0.5rem",
              }}
            >
              {messages[holdType]}
              {contactEmails[holdType] && (
                <a href={`mailto:${contactEmails[holdType]}`}>
                  {contactEmails[holdType]}
                </a>
              )}
              <br />
            </Typography>
          ))}

          {/* RENDER NOTICES */}
          {/* Show notices if we have notices
              - Show if currentStudent.ses_currentstudent is true (standard case)
              - Also show if currentStudent is empty/undefined but notices exist (handles case where student only has update notice messages)
              This ensures notices display for all scenarios: holds only, notices only, or both */}
          {noticeMessages?.length > 0 &&
            (currentStudent?.ses_currentstudent === true ||
              !currentStudent ||
              Object.keys(currentStudent || {}).length === 0) && (
              <Typography
                style={{
                  background: "#efd6e1",
                  color: "black",
                  marginLeft: "4.8rem",
                  width: "90%",
                  paddingBottom: "0.2rem",
                }}
              >
                {noticeMessages.map((element, index) => (
                  <div key={index} style={{ marginBottom: "1rem" }}>
                    {element.ses_notice}
                  </div>
                ))}
              </Typography>
            )}
          <br />
        </>
      ) : (
        <Toolbar disableGutters>
          <Grid container item xs={12} sm={11} style={{ margin: "0 auto" }}>
            <NavigationMenuItem />
          </Grid>
        </Toolbar>
      )}
    </AppBar>
  );
};

export default NavigationItems;
